<template>
  <div id="project-form">
    <form @submit.prevent="submit">
      <section>
        <b-field label="Name">
          <b-input v-model="form.name"/>
        </b-field>
        <b-field label="Partner">
          <b-select v-model="form.partner" placeholder="Select partner">
            <option value disabled>Select partner</option>
            <option
              v-for="partner in partners"
              :key="partner.id"
              :value="partner.id"
            >{{ partner.name }}</option>
          </b-select>
        </b-field>
        <b-field label="Games"/>
        <b-field>
          <b-upload v-model="uploads">
            <a class="button is-primary">
              <b-icon icon="upload"></b-icon>
              <span>Click to upload</span>
            </a>
          </b-upload>
          <span v-if="uploads" class="file-name">{{ uploads.name }}</span>
        </b-field>
      </section>
      <input class="button" type="submit" value="Save">
      <router-link class="button submit" to="/providers">Back</router-link>
    </form>
  </div>
</template>

<script>
/* global FileReader */

import http from '@/lib/utils/http'
import { error, success } from '@/lib/utils/toast'

export default {
  props: ['id'],
  data() {
    return {
      form: {
        name: '',
        partner: '',
        gameList: '',
      },
      uploads: [],
      errors: {},
      partners: {},
    }
  },
  watch: {
    uploads(val) {
      this.handleFileUpload(val)
    },
  },
  methods: {
    load() {
      if (this.id) {
        this.loadProvider(this.id)
      }
      this.loadPartners()
    },
    loadPartners() {
      return http
        .get('partners')
        .then(resp => {
          this.partners = resp.data
        })
        .catch(() => {})
    },
    loadProvider(providerId) {
      const loader = this.$loading.open()
      http
        .get('providers/' + providerId)
        .then(resp => {
          const provider = resp.data
          this.form.name = provider.name
          this.form.partner = provider.partner.id
        })
        .catch(() => {})
        .then(() => {
          loader.close()
        })
    },

    handleFileUpload(file) {
      let reader = new FileReader()
      reader.onload = () => {
        this.form.gameList = reader.result
      }
      reader.readAsDataURL(file)
    },

    submit() {
      const body = this.form
      const request = this.id ? http.put('providers/' + this.id, body) : http.post('providers', body)

      request
        .then(() => {
          this.$toast.open(success())
        })
        .catch(errors => {
          this.errors = errors.response.data
          this.$toast.open(error())
        })
    },
  },
  created() {
    this.load()
  },
}
</script>

<style>
.file-name {
  border-color: #dbdbdb;
  border-style: solid;
  border-width: 1px 1px 1px 0;
  display: block;
  max-width: 16em;
  overflow: hidden;
  text-align: left;
  text-overflow: ellipsis;
  margin-top: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/Providers/Form.vue